import { streamAgentTurn } from "./agentStream";
import type { WireMessage } from "./agentMemory";

const DEFAULT_IDLE_TIMEOUT_MS = 60_000;

// One no-tools completion through the assistant's own stream endpoint, awaited to the full text.
// Used by the draft tool — nothing renders while it runs, so deltas are ignored.
export const streamCompletion = async (
  messages: WireMessage[],
  model: string | undefined,
  conversationHasReadFiles: boolean,
  signal?: AbortSignal,
  idleTimeoutMs: number = DEFAULT_IDLE_TIMEOUT_MS,
): Promise<{ text: string; complete: boolean }> => {
  const outcome = await streamAgentTurn({ messages, model, conversationHasReadFiles }, {}, { idleTimeoutMs, signal });
  if (!outcome.text.trim()) {
    throw new Error("Completion delivered no text");
  }
  return { text: outcome.text, complete: !outcome.errored && outcome.finishReason !== "length" };
};
